<template>
  <div>
    <a :href="googleSignInUrl"><b-img :src="googleSignInButton" alt="Sign in with Google" width="200" /></a>
  </div>
</template>

<script>
import buildUrl from 'build-url';
import { BImg } from 'bootstrap-vue'
import googleSignInButton from '../../img/btn_google_signin_dark_pressed_web.png'

export default {
  data: function() {
    return {
      googleSignInUrl: buildUrl(
        '/auth/google_oauth2', {
          queryParams: {
            origin: location.href
          }
        }
      ),
      googleSignInButton: googleSignInButton
    };
  },
  components: {
    'b-img': BImg
  }
}
</script>

<style scoped>
</style>
